import { DataTableCol } from "../../../components/tables/types";

export const MeetsDataGridCols: DataTableCol[] = [
    {
        title: 'Created Date',
        control: 'createdAt',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Title',
        control: 'title',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Link',
        control: 'link',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Meet Date',
        control: 'meetDate',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Actions',
        control: 'both',
        sortable: false,
        isEdit: true,
        isDelete: true,
        canShowColumn: true
    },
];